import type { GetStaticPaths, GetStaticProps } from "next"
import {
  type CategoryArchiveProps,
  getCategoryArchive,
  getCategoryPagePaths,
} from "@/components/resources/data/archives"
import { isResourceCategory } from "@/components/resources/data/markdown/categories"
import { SiteLayout } from "@/components/resources/layouts/site"
import { ResourceCategoryArchive } from "@/components/resources/templates/ResourceCategoryArchive"
import { parsePageParam } from "@/components/resources/utils/pagination"

const Archive = (props: CategoryArchiveProps) => <ResourceCategoryArchive {...props} />

Archive.getLayout = SiteLayout

export default Archive

// Blocking fallback: the News archive lists newsletter issues, which can add a page between deploys
export const getStaticPaths: GetStaticPaths = async () => ({
  paths: await getCategoryPagePaths(),
  fallback: "blocking",
})

export const getStaticProps: GetStaticProps<
  CategoryArchiveProps,
  { category: string; n: string }
> = async ({ params }) => {
  const category = params?.category
  const page = parsePageParam(params?.n)
  const props =
    category && isResourceCategory(category) && page
      ? await getCategoryArchive(category, page)
      : null
  // The 404 revalidates too: a Beehiiv outage only shortens the list for a while
  return props ? { props, revalidate: 180 } : { notFound: true, revalidate: 180 }
}
